"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.string.trim.js");

var _react = _interopRequireDefault(require("react"));

var _reactRenderHtml = _interopRequireDefault(require("react-render-html"));

var _marked = require("marked");

var _propTypes = require("prop-types");

var _lodash = _interopRequireDefault(require("lodash"));

var MarkdownHtml = function MarkdownHtml(_ref) {
  var options = _ref.options,
      children = _ref.children,
      id = _ref.id;

  if (!_lodash["default"].isUndefined(children)) {
    var html = (0, _marked.marked)(children.trim()); // marked - WORKED

    var output = (0, _reactRenderHtml["default"])(html); // render me

    if (id) {
      return /*#__PURE__*/_react["default"].createElement("span", {
        id: id
      }, output);
    }

    return output;
  }

  return null;
};

MarkdownHtml.defaultProps = {
  options: {},
  children: undefined,
  id: undefined
};
MarkdownHtml.propTypes = {
  id: _propTypes.string,
  options: _propTypes.object,
  children: _propTypes.string
};

var MarkdownHtmlMemo = /*#__PURE__*/_react["default"].memo(MarkdownHtml);

var _default = MarkdownHtmlMemo;
exports["default"] = _default;